/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Fraction } from './Fraction';
const RubricRowItemParser = /* #__PURE__ */ parsers.object([
    ['header', codecString],
    ['description', codecString],
    ['points', Fraction],
]);
export class RubricRowItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricRowItemParser.decode(input).map(res => new RubricRowItem(res));
    }
    static unsafeDecode(input) {
        return RubricRowItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricRowItemParser.encode(data);
    }
    static schema() {
        return RubricRowItemParser.schema();
    }
}
